import React, { useState } from 'react';
import './FAQ.css';
import ScrollReveal from '../components/ScrollReveal';

const ARTICLES = [
  {
    id: 1,
    title: 'ස්කිල් ටෙස්ට් එකේදී මොකක්ද කරන්න තියෙන්නේ?',
    category: 'Korean Problems',
    shortDesc: 'ස්කිල් ටෙස්ට් එක හෙවත් නිපුණතා පරීක්ෂණය ගත් කල නිෂ්පාදන , ධීවර , ඉදිකිරීම් , කෘෂි කාර්මික යන අංශවලට පොදුවේ මුහුණ දිය යුතු පරීක්ෂණ...',
    content: `
      <p>ස්කිල් ටෙස්ට් එක හෙවත් නිපුණතා පරීක්ෂණය ගත් කල නිෂ්පාදන , ධීවර , ඉදිකිරීම් , කෘෂි කාර්මික යන අංශවලට පොදුවේ මුහුණ දිය යුතු පරීක්ෂණ ඇති අතර තවද ඉහත අංශ සඳහා වෙන වෙනම වෙන් වූ ක්‍රියාකාරකම් ඇති බව පෙන්වා දිය යුතුය.</p>
      
      <h4>1) ශාරීරික යෝග්‍යතා පරීක්ෂණය</h4>
      <p>මෙහිදී අතේ ශක්තිය , කොන්දේ ශක්තිය , උස , බර සහ වර්ණ අන්ධතාවය පරීක්ෂාවට ලක් කරනු ලැබේ.</p>
      
      <h4>2) සම්මුඛ පරීක්ෂණය</h4>
      <p>මෙහිදී මුලින් ම කොරියානු බසින් ආචාර කොට තමා ගැන හැඳින්වීමක් කොරියානු බසින් කළ යුතු අතර එය වීඩියෝ පටිගත කිරීමක් සිදු කරනු ඇත.</p>
      <p>ඉන් පසුව යම් විධානයන් කිහිපයක් කොරියානු අධීක්ෂක විසින් කරනු ලබන අතර ඒවාට අනුව ක්‍රියා කළ යුතුය.(නිදසුනක් ලෙස වම ඇත උස්සන්න යනුවෙන් කොරියානු බසින් පැවසු විට ඔබ එය කළ යුතුය.)</p>
      <p>ඉන් පසුව ඔබ මුලින් තෝරා ගත් අංශයට අදාළ රූප සටහන් පෙන්වා ඒවායේ නම් කොරියානු බසින් පිළිතුරු දිය යුතුය. ඔරලෝසුවේ පෙන්වන වෙලාව කොරියානු බසින් කිව යුතුය.</p>
      
      <h4>3) කුසලතා පරීක්ෂණය</h4>
      <p>කුසලතා පරීක්ෂණය යටතේ සෑම අංශයකටම පොදු ක්‍රියාකාරකම් ලෙස වළලු දැමීමේ ක්‍රියාකාරකම සහ කූරු දැමීමේ ක්‍රියාකාරකම පෙන්වා දිය යුතුය.</p>
      <p>මෙහිදී තමා තෝරා ගත අංශය එනම් නිෂ්පාදන , ධීවර , ඉදිකිරීම් , කෘෂි කාර්මික යන අංශ සඳහා වෙන් වෙන් වූ ක්‍රියාකාරකම් කිරීමට සිදු වේ. මේ සියලු කරුණු කොරියානු භාෂා පරීක්ෂණය සමත් වූ පසු ඔබ තෝරා ගන්නා ගුරුවරයා විසින් හෝ අපගේ app එක මඟින් පැහැදිලි කර දෙනු ඇත.</p>
    `,
    date: 'May 05, 2026',
    icon: '🎯'
  },
  {
    id: 2,
    title: 'කොරියානු විභාගය කරලා සමත් වූ අය web එකේ ඉන්නේ ලකුණු ගත්ත පිළිවෙලටද?',
    category: 'Korean Problems',
    shortDesc: 'විභාගයේ වැඩිම ලකුණු ලබාගත් අය list එකේ මුලට යනවා යන ප්‍රකාශනය නිවැරදි නොවේ...',
    content: `
      <p>විභාගයේ වැඩිම ලකුණු ලබාගත් අය list එකේ මුලට යනවා යන ප්‍රකාශනය නිවැරදි නොවේ. වැඩිම ලකුණු ලබා ගත් අයට කලින් අවම ලකුණු ලබා ගත් අය කොරියාවට කලින් ගිය අවස්ථා බොහෝ සේ දක්නට ලැබුණු අවස්ථා ඇත.</p>
    `,
    date: 'May 05, 2026',
    icon: '📊'
  },
  {
    id: 3,
    title: 'මගේ දබර ඇඟිල්ලේ නියපොත්ත නෑ. මේක වෛද්‍ය පරීක්ෂණයේදී ගැටළුවක් වේද?',
    category: 'Korean Problems',
    shortDesc: 'ඇඟිලිවල පුරුක් ඉවත් කර ඇත්නම් ගැටළුවක් විය හැකි නමුත් නියපොත්ත නැති වීම ගැටළුවක් නොවේ...',
    content: `
      <p>ඇඟිලිවල පුරුක් ඉවත් කර ඇත්නම් ගැටළුවක් විය හැකි නමුත් නියපොත්ත නැති වීම ගැටළුවක් නොවේ.</p>
    `,
    date: 'May 05, 2026',
    icon: '🩺'
  },
  {
    id: 4,
    title: 'අපි කොරියන් විභාගයට Admission ගන්න ඕන ගුරුවරයෙක් මාර්ගයෙන්මද?',
    category: 'Korean Problems',
    shortDesc: 'ගුරුවරු සිටින්නේ මග පෙන්වන්න පමණි. ඔබ විසින් Admission නිකුත් කරන ස්ථානයට ගොස් එය ලබාගත යුතුය...',
    content: `
      <p>ගුරුවරු සිටින්නේ මග පෙන්වන්න පමණි. ඔබ විසින් Admission නිකුත් කරන ස්ථානයට ගොස් එය ලබාගත යුතුය.</p>
    `,
    date: 'May 05, 2026',
    icon: '📝'
  },
  {
    id: 5,
    title: 'ප්ලාස්ටික් සැත්කමක් කර ඇති පුද්ගලයකුට Medical එකේදී ගැටළු ඇතිවන වාද?',
    category: 'Korean Problems',
    shortDesc: 'නිදසුනක් ලෙස විදේශ ගමන් බලපත්‍රය සැකසූ පසු කරන ලද සැත්කමක් හේතුවෙන් මුහුණේ යම් වෙනසක් පවතී නම්...',
    content: `
      <p>නිදසුනක් ලෙස විදේශ ගමන් බලපත්‍රය සැකසූ පසු කරන ලද සැත්කමක් හේතුවෙන් මුහුණේ යම් වෙනසක් ගමන් බලපත්‍රය හා සසඳන විට පවතී නම් ගැටළුවක් මතුවිය හැකිය. ඒ හැර වෙනත් විශේෂ ගැටළුවක් ඇති නොවේ.</p>
    `,
    date: 'May 05, 2026',
    icon: '🏥'
  },
  {
    id: 6,
    title: 'කොරියානු සිහිනය සැබෑ කරගැනීමට අධ්‍යාපන සුදුසුකම් කොපමණ දුරකට අවශ්‍ය ද?',
    category: 'Korean Problems',
    shortDesc: 'අ.පො.ස. සාමාන්‍ය පෙළ විභාගය සමත් නම් ප්‍රමාණවත් වේ යැයි මාගේ පෞද්ගලික අදහසයි...',
    content: `
      <p>අ.පො.ස. සාමාන්‍ය පෙළ විභාගය සමත් නම් ප්‍රමාණවත් වේ යැයි මාගේ පෞද්ගලික අදහසයි. කොරියානු භාෂා විභාගය සමත් වීම ම මූලික සුදුසුකමයි.</p>
    `,
    date: 'May 05, 2026',
    icon: '🎓'
  },
  {
    id: 7,
    title: 'එක් ඇසකට පමණක් අක්ෂි ගැටළු ඇති පුද්ගලයෙකුට අක්ෂි පරික්ෂාවේදී ගැටළු ඇතිවනවාද?',
    category: 'Korean Problems',
    shortDesc: 'අක්ෂි ගැටළුවක් යනුවෙන් අදහස් කරන්නේ සම්පුර්ණයෙන්ම ඇසක් නොපෙනෙන තත්වයක් නම්...',
    content: `
      <p>අක්ෂි ගැටළුවක් යනුවෙන් අදහස් කරන්නේ සම්පුර්ණයෙන්ම ඇසක් නොපෙනෙන තත්වයක් නම් ගැටළුවක් පැන නැගිය හැකි අතර පෙනීමේ දුර්වලතාවයක් නම් ඇස්කණ්ණාඩි භාවිතා කරන විට පෙනීමේ ප්‍රශ්නයක් නැත්නම් ගැටළුවක් නොවේ.</p>
    `,
    date: 'May 05, 2026',
    icon: '👁️'
  },
  {
    id: 8,
    title: 'කුසලතා පරීක්ෂණයේදී විශේෂ වන කරුණු (සුදුසුකම්) මොනවාද?',
    category: 'Korean Problems',
    shortDesc: 'කුසලතා පරීක්ෂණය මූලික කොටස් 3කින් පවත්වනු ලබන අතර පළමු කොටස ලෙස ශාරීරික යෝග්‍යතා පරීක්ෂණය...',
    content: `
      <p>කුසලතා පරීක්ෂණය මූලික කොටස් 3කින් පවත්වනු ලබන අතර පළමු කොටස ලෙස ශාරීරික යෝග්‍යතා පරීක්ෂණය හඳුන්වා දිය හැකි අතර එහිදී ශරීරයේ සමබරතාවය සහ දරා ගැනීමේ හැකියාව පිළිබඳ පරීක්ෂා කරන අතර දෙවන පරීක්ෂණය ලෙස ක්‍රියාකාරකම් පරීක්ෂණය පෙන්වා දිය හැකිය.</p>
      <p>මෙහිදී කලින් ඔබ තෝරා ගන්නා ලද අංශයට අනුව පෙර පුහුණුව ලත් යම් යම් ක්‍රියායාකාරකම් කොරියානු විනිසුරු මඩුල්ල ඉදිරියේ නිශ්චිත කාල සීමාවකට යටත්ව කිරීමට සිදු වේ.</p>
      <p>අවසාන පරීක්ෂණය ලෙස සම්මුඛ පරීක්ෂණය පෙන්වා දිය හැකිය. මෙහිදී කොරියානු විනිසුරුවරයෙකු සහ ශ්‍රී ලාංකික භාෂා පරිවර්තකයෙකු ඉදිරියේ අසන ප්‍රශ්න කිහිපයකට කොරියානු භාෂාවෙන් පිළිතුරු දිය යුතු මෙන්ම තමා ගැන කොරියානු භාෂාවෙන් හැඳින්වීමක් කළ යුතුය. මෙය ඔබ ඉදිරියේ ඇති කැමරාවක පටිගත වනු ලැබේ.</p>
      <p>ඉදිරියේදී කොරියානු ජාතික ආයතන ප්‍රධානියෙක් ශ්‍රමිකයෙකු තෝරා ගැනීමේදී ඉහත කරුණු මනා සේ පරීක්ෂා කර බලා සුදුසු කෙනා තෝරා ගනී.</p>
    `,
    date: 'May 05, 2026',
    icon: '🏗️'
  },
  {
    id: 9,
    title: 'විභාගය සමත් වූ පසු කුසලතා පරීක්ෂණය පැවැත්වෙන්නේ කොපමණ දිනකට පසු ද?',
    category: 'Korean Problems',
    shortDesc: 'දින ගණන නිශ්චිතව කිව නොහැකිය. විභාගය පවත්වා මසක පමණ කාලයකට පසුව...',
    content: `
      <p>දින ගණන නිශ්චිතව කිව නොහැකිය. විභාගය පවත්වා මසක පමණ කාලයකට පසුව කුසලතා පරීක්ෂණය පවත්වන අවස්ථාද ඇති අතර එය තීරණය කරනු ලබන්නේ ඒ ඒ වසරට නියමිත කෝටා ප්‍රමාණය අනුව පවත්වන දිනය වෙනස් විය හැකිය.</p>
    `,
    date: 'May 05, 2026',
    icon: '⏳'
  },
  {
    id: 10,
    title: 'ජපානයට වඩා වැඩි ආදායමක් කොරියාවේ සාමාන්‍ය රැකියාවක නිරත වී ගත හැකිද?',
    category: 'Korean Problems',
    shortDesc: 'සමස්තයක් ලෙස ගත් විට ජපානයේ වැටුප කොරියාවට වඩා මදක් වැඩි නමුත්...',
    content: `
      <p>සමස්තයක් ලෙස ගත් විට ජපානයේ වැටුප කොරියාවේ වැටුපට වඩා මදක් වැඩි නමුත් ආහාර, නවාතැන් වැනි පහසුකම් ජපානයේදී තමා විසින් සපුරා ගත යුතු නමුත් කොරියාවේ බහුතරයක් ආයතන මේ සියලු පහසුකම් නොමිලේ ලබා දෙන බැවින් ඉතුරුකරගත හැකි මුදල ජපානයට වඩා වැඩි යැයි මාගේ පෞද්ගලික අදහසයි.</p>
    `,
    date: 'May 05, 2026',
    icon: '💰'
  },
  {
    id: 11,
    title: 'සාමාන්‍ය කොරියානු රැකියාවකදී ලැබිය හැකි වැටුප කොපමණද?',
    category: 'Korean Problems',
    shortDesc: 'අතිකාල දීමනා හැර දල වශයෙන් මූලික වැටුප ශ්‍රී ලංකා මුදලින් රු.320,000ක් පමණ...',
    content: `
      <p>අතිකාල දීමනා හැර දල වශයෙන් මූලික වැටුප ශ්‍රී ලංකා මුදලින් රු.320,000ක් පමණ ලැබෙන අතර අතිකාල දීමනා හා නිවාඩු දින දීමනා සමඟ ගත් කල රු.450,000ක් පමණ වැටුපක් ලබා ගත හැකිය. මෙය ආයතනයෙන් ආයතනයට වෙනස් වේ.</p>
    `,
    date: 'May 05, 2026',
    icon: '💵'
  },
  {
    id: 12,
    title: 'අවුරුද්දකට කොරියානු විභාගයන් කොපමණ රජය විසින් පවත්වනවාද?',
    category: 'Korean Problems',
    shortDesc: 'සාමාන්‍යයෙන් වසරකට එක් වරක් පවත්වන බව පෙන්වා දිය හැකිය. මෙය රජයේ අවශ්‍යතාවය මත වෙනස් විය හැකිය...',
    content: `
      <p>මෑත කාලය පුරාවටම මා දැනුවත් ආකාරයට එකම එක වසරක පමණක් කොරියානු විභාගය දෙවරක් පවත්වා ඇති අතර සාමාන්‍යයෙන් වසරකට එක් වරක් පවත්වන බව පෙන්වා දිය හැකිය. මෙය කොරියානු රජයේ අවශ්‍යතාවය මත වෙනස් විය හැකි බව ද කිව යුතුය.</p>
    `,
    date: 'May 05, 2026',
    icon: '📅'
  },
  {
    id: 13,
    title: 'Student Visa භාවිතා කර කොරියාවට යාමට සහ ශිෂ්‍යත්ව ලබා ගැනීමට හැකිද?',
    category: 'Korean Problems',
    shortDesc: 'Student visa භාවිතා කර කොරියාවට යාමට අවස්ථාව ලබා ගත හැකිය. ශිෂ්‍යත්ව වැඩසටහන් පිළිබඳ තොරතුරු...',
    content: `
      <p>Student visa භාවිතා කර කොරියාවට යාමට අවස්ථාව ලබා ගත හැකිය. ඒ ඒ පළාත්වල තිබෙන විශ්ව විද්‍යාලවල නීති රෙගුලාසි එකිනෙකට වෙනස් බවක් දක්නට ලැබේ. එමෙන්ම කොරියාවේ විශ්ව විද්‍යාලවල ශිෂ්‍යත්ව වැඩසටහන් ක්‍රියාත්මක කරන අතර නොමිලේම අයදුම් කර කොරියාවේ විශ්ව විද්‍යාලවලට ඇතුලත් විය හැකිය.</p>
      <p>පහත සුදුසුකම් ඇති අයට මෙම ශිෂ්‍යත්ව ක්‍රමය යටතේ අයදුම් කළ හැකිය:</p>
      <ul>
        <li>උසස් පෙළ සමත් අයට</li>
        <li>මෙරට උපාධියක් ඇති අයට පශ්චාත් උපාධිය හැදෑරීම සඳහා</li>
        <li>KOIKA ආයතනය හරහා රජයේ සේවකයින්ට වැඩිදුර අධ්‍යාපනය හැදෑරීමට</li>
      </ul>
      <p>මෙය ඉතාම තරඟකාරී අවස්ථාවක් වන අතර රටවල් 60කින් පමණ මේ සඳහා අයදුම් කරනු ලැබේ.</p>
      <p>කොරියානු භාෂාව පිළිබඳ මූලික දැනුමක් ලබා ගැනීමෙන් පසු මේ සඳහා අයදුම් කර ඔබ කොරියාවට ඇතුළුවන්නේ නම් කිසිදු ගැටලුවකින් තොරව ඔබට අධ්‍යාපන කටයුතු කරගෙන යා හැකි අතර අමතර රැකියා කර මුදල් ද ඉපයීමේ අවස්ථාව හිමි වනු ඇත. වැඩිදුර විස්තර සඳහා <b>Korean Government Scholarship Program (KGSP)</b> වෙබ් අඩවිය පරීක්ෂා කරන්න.</p>
    `,
    date: 'May 05, 2026',
    icon: '🎓'
  },
  {
    id: 14,
    title: 'Student visa පාවිච්චි කර කොරියාවට යෑමට හැකිද? එහිදී ඇතිවන ගැටළු මොනවාද?',
    category: 'Korean Problems',
    shortDesc: 'Student visa භාවිතා කර කොරියාවට යාමට අවස්ථාව ලබා ගත හැකිය. විශ්ව විද්‍යාල රෙගුලාසි සහ...',
    content: `
      <p>Student visa භාවිතා කර කොරියාවට යාමට අවස්ථාව ලබා ගත හැකිය. ඒ ඒ පළාත්වල තිබෙන විශ්ව විද්‍යාලවල නීති රෙගුලාසි එකිනෙකට වෙනස් බවක් දක්නට ලැබේ. එමෙන්ම කොරියාවේ විශ්ව විද්‍යාලවල ශිෂ්‍යත්ව වැඩසටහන් ක්‍රියාත්මක කරන අතර නොමිලේම අයදුම් කර කොරියාවේ විශ්ව විද්‍යාලවලට ඇතුලත් විය හැකිය.</p>
      <p>පහත සුදුසුකම් ඇති අයට මෙම ශිෂ්‍යත්ව ක්‍රමය යටතේ අයදුම් කළ හැකිය:</p>
      <ul>
        <li>උසස් පෙළ සමත් අයට</li>
        <li>මෙරට උපාධියක් ඇති අයට පශ්චාත් උපාධිය හැදෑරීම සඳහා</li>
        <li>KOIKA ආයතනය හරහා රජයේ සේවකයින්ට වැඩිදුර අධ්‍යාපනය හැදෑරීමට</li>
      </ul>
      <p>මෙය ඉතාම තරඟකාරී අවස්ථාවක් වන අතර රටවල් 60කින් පමණ මේ සඳහා අයදුම් කරනු ලැබේ.</p>
      <p>කොරියානු භාෂාව පිළිබඳ මූලික දැනුමක් ලබා ගැනීමෙන් පසු මේ සඳහා අයදුම් කර ඔබ කොරියාවට ඇතුළුවන්නේ නම් කිසිදු ගැටලුවකින් තොරව ඔබට අධ්‍යාපන කටයුතු කරගෙන යා හැකි අතර අමතර රැකියා කර මුදල් ද ඉපයීමේ අවස්ථාව හිමි වනු ඇත. වැඩිදුර විස්තර සඳහා <b>Korean Government Scholarship Program (KGSP)</b> වෙබ් අඩවිය පරීක්ෂා කරන්න.</p>
    `,
    date: 'May 05, 2026',
    icon: '🛂'
  },
  {
    id: 15,
    title: 'කලින් කරන ලද ශල්‍යකර්මයක් නිසා කොරියානු ගමනට බලපෑම් ඇති වේද?',
    category: 'Korean Problems',
    shortDesc: 'මෙය එතරම් ලොකු ගැටළුවක් නොවන බව පෙන්වා දිය හැකිය. සාමාන්‍ය මැහුම් සහිත තුවාල...',
    content: `
      <p>මෙය එතරම් ලොකු ගැටළුවක් නොවන බව පෙන්වා දිය හැකිය. නමුත් විශාල ශල්‍යකර්මයන්ට භාජනය වූ අය ශරීරයේ අභ්‍යන්තරයේ ලෝහ පටි වැනි දෑ ඇති අයට ගැටළුවක් ඇතිවන නමුත් සාමාන්‍ය මැහුම් සහිත සනීප වූ තුවාල ඇති අයට මෙය බලපාන්නේ නැත.</p>
    `,
    date: 'May 05, 2026',
    icon: '🏥'
  },
  {
    id: 16,
    title: 'අක්ෂි පරීක්ෂාවේදී ඇතිවන ගැටළු ඉදිරියට බලපාන්නේ කෙසේද?',
    category: 'Korean Problems',
    shortDesc: 'අක්ෂි පරීක්ෂාව යනු ඇස් පෙනීමේ දුර්වලතාවය නොව වර්ණ අන්ධතාවයයි...',
    content: `
      <p>අක්ෂි පරීක්ෂාව යනු ඇස් පෙනීමේ දුර්වලතාවය නොව වර්ණ අන්ධතාවයයි. වර්ණ අන්ධතාවය යන රෝගී තත්වය ඇති කිසිම අයදුම්කරුවෙකුට හෝ අයදුම්කාරියකට කොරියාවට යාම සඳහා අවස්ථාව හිමිවන්නේ නැත.</p>
      <p>විභාග ප්‍රවේශ පත්‍ර නිකුත් කරන දින මුලින් ම එම පරීක්ෂණයට භාජනය වන අතර එය විදේශ සේවා නියුක්ති කාර්යාංශ නිලධාරීන් විසින් සිදු කරනු ලබයි. වර්ණ අන්ධතාවය ඇති ඇතැමුන් විවිධ ක්‍රම මඟින් එහිදී සමත් වන නමුත් නිපුණතා පරීක්ෂණයේදී කොරියානු විනිශ්ය මණ්ඩලයක් ඉදිරියේ නැවත එම පරීක්ෂණයට ලක් කරන අතර වර්ණ අන්ධතාවය ඇති කිසිවෙකුට එය සමත් විය නොහැක.</p>
    `,
    date: 'May 05, 2026',
    icon: '🎨'
  },
  {
    id: 17,
    title: 'ගැහැණු ළමයෙක් සඳහා කොරියාවේ ඇති අවස්ථාවන් මොනවද?',
    category: 'Korean Problems',
    shortDesc: 'කොරියාව තුල රැකියා පිළිබඳ කතා කිරීමේදී ගැහැණු පිරිමි භේදයකින් තොරව...',
    content: `
      <p>කොරියාව තුල රැකියා පිළිබඳ කතා කිරීමේදී ගැහැණු පිරිමි භේදයකින් තොරව සියලු දෙනාට ලැබෙනුයේ සමාන රැකියා අවස්ථාවන්ය.</p>
    `,
    date: 'May 05, 2026',
    icon: '👩‍💼'
  },
  {
    id: 18,
    title: 'ගැහැණු ළමුන්ට කොරියාවට යෑමට වරම් හිමි වන ප්‍රමාණය අඩුද?',
    category: 'Korean Problems',
    shortDesc: 'මුල් කාල වකවානුවේදී සමාන අවස්ථාවන් ලැබුණු නමුත් වර්තමානය වන විට...',
    content: `
      <p>මුල් කාල වකවානුවේදී ගැහැණු ළමුන්ට පිරිමි ළමයින්ට මෙන් සමාන අවස්ථාවන් ලැබුණු නමුත් වර්තමානය වන විට මෙය ඉන්දුනීසියාව , වියට්නාමය , කාම්බෝජය වැනි රටවල් හා සංසන්දනය කිරීමේදී ශ්‍රී ලංකාවේ ගැහැණු ළමුන්ට අඩු රැකියා අවස්ථාවන් ලැබෙන බව කණගාටුවෙන් වුවද ප්‍රකාශ කළ යුතුය.</p>
    `,
    date: 'May 05, 2026',
    icon: '📊'
  },
  {
    id: 19,
    title: 'කොරියානු විභාගයට ඇතුළත් වීම සඳහා අවශ්‍ය සුදුසුකම් මොනවාද?',
    category: 'Korean Problems',
    shortDesc: 'විභාගය සඳහා ඇතුළත් වීමට අවශ්‍ය විදේශ ගමන් බලපත්‍රය, වයස සහ අනෙකුත් නීතිමය සුදුසුකම්...',
    content: `
      <p>කොරියානු විභාගයට ඇතුළත් වීම සඳහා පහත සඳහන් මූලික සුදුසුකම් සපුරා තිබිය යුතුය:</p>
      <ul>
        <li><b>විදේශ ගමන් බලපත්‍රය:</b> සියලුම රටවලට යොමට වලංගු විදේශ ගමන් බලපත්‍රයක් (All Countries Passport) තිබිය යුතු අතර එය විභාග ප්‍රවේශ පත්‍රය නිකුත් කරන දින වන විට ඉදිරියට වසර 2ක් වත් වලංගු කාලය තිබිය යුතුය.</li>
        <li><b>වයස:</b> විභාග අපේක්ෂකයකු විභාග ප්‍රවේශ පත්‍ර නිකුත් කරන දිනට වයස අවුරුදු 18ත් 39ත් අතර වයස් කාණ්ඩයේ විය යුතුය.</li>
        <li><b>නීතිමය වාර්තා:</b> අයදුම්කරුවන් කොරියාවෙන් පිටුවහල් කිරීමේ හෝ පිටත් කිරීමේ නියෝග වාර්තාවක් නොතිබිය යුතුය.</li>
        <li><b>නීති විරෝධී රැඳී සිටීම්:</b> නීති විරෝධී ශ්‍රමිකයෙකු ලෙස කොරියාව තුල එක දිනක් හෝ රැඳී සිටි පුද්ගලයෙකු නොවිය යුතුය.</li>
        <li><b>අපරාධ වාර්තා:</b> යම් අපරාධ ක්‍රියාවක් හේතුවෙන් නීතියෙන් දඬුවම් ලබන හෝ ඇප මත සිටින පුද්ගලයින්ට මේ අවස්ථාව අහිමි වනු ඇත.</li>
        <li><b>ගමන් තහනම්:</b> අයදුම්කරුවන් ශ්‍රී ලංකාවෙන් පිටත් වීමේ තහනමකට ලක් වූ අයෙකු නොවිය යුතුය.</li>
        <li><b>සෞඛ්‍ය සුදුසුකම්:</b> වර්ණ අන්ධතාවයෙන් පෙලෙන අයෙකු නොවිය යුතුය. (වර්ණ අන්ධතාවය යනු එක වර්ණයකින් තවත් වර්ණයක් හඳුනා ගැනීමේ දුර්වලතාවයයි.)</li>
      </ul>
    `,
    date: 'May 05, 2026',
    icon: '📜'
  },
  {
    id: 20,
    title: 'විභාගය සමත් වී කොරියාවට යාමට එකවර කොපමණ පිරිසකට යා හැකිද?',
    category: 'Korean Problems',
    shortDesc: 'මෙය තීරණය කරනු ලබන්නේ ඒ ඒ වර්ෂවලදී ලැබෙන කෝටා ප්‍රමාණය අනුවයි...',
    content: `
      <p>මෙය තීරණය කරනු ලබන්නේ ඒ ඒ වර්ෂවලදී ලැබෙන කෝටා ප්‍රමාණය අනුවයි. විභාගය සමත් වූ පමණින් සියලු අපේක්ෂකයින්ට කොරියාවට යා හැකි යැයි ස්ථිර වශයෙන් කිව නොහැකිය.</p>
      <p>කොරියානු සේවා යෝජකයින් විසින් සේවා ගිවිසුමක් (Job Contract) පැමිණියහොත් ඔබට කොරියාවට යාමට හැකි වනු ඇත. එකවර පුද්ගලයින් 50ක් 60ක් වැනි කණ්ඩායම් වශයෙන් කොරියාවට පිටත් කර හරිනු ලැබේ.</p>
    `,
    date: 'May 05, 2026',
    icon: '✈️'
  },
  {
    id: 21,
    title: 'කොරියාවට යෑමේදී උස පිළිබඳ සැළකිලිමත් විය යුතුද?',
    category: 'Korean Problems',
    shortDesc: 'මෙය නිපුණතා පරීක්ෂණයේ දී පරීක්ෂාවට ලක් කරන අතර අවම උස පිළිබඳ...',
    content: `
      <p>මෙය නිපුණතා පරීක්ෂණයේ දී පරීක්ෂාවට ලක් කරන අතර සාමාන්‍යයෙන් පහත සඳහන් අවම උස තිබිය යුතුය:</p>
      <ul>
        <li><b>පිරිමි ළමුන් සඳහා:</b> අඩි 5යි අඟල් 02ක් (5' 2")</li>
        <li><b>ගැහැණු ළමුන් සඳහා:</b> අඩි 4 යි අඟල් 08ක් (4' 8")</li>
      </ul>
    `,
    date: 'May 05, 2026',
    icon: '📏'
  },
  {
    id: 22,
    title: 'විභාගය පවත්වන්නේ කවදාද?',
    category: 'Korean Problems',
    shortDesc: 'සාමාන්‍යයෙන් සෑම වසරක ම මාර්තු හෝ අප්‍රේල් මස පවත්වනු ලබන අතර...',
    content: `
      <p>විභාගය පවත්වන දිනය තීරණය කරනු ලබන්නේ කොරියානු මානව සම්පත් සංවර්ධන ආයතනය (HRD Korea) මගින් වන අතර සාමාන්‍යයෙන් සෑම වසරක ම මාර්තු හෝ අප්‍රේල් මස පවත්වනු ලැබේ.</p>
      <p>විභාග මධ්‍යස්ථාන එකක් පමණක් ඇති බැවින් ද, එහි එක් වරකට අපේක්ෂකයින් 75 දෙනකුට පමණක් ඇතුළත් විය හැකි බැවින් විභාගය මාස කිහිපයක් පුරා පැවැත්වීමට සිදුවන බව පෙන්වා දිය යුතුය.</p>
    `,
    date: 'May 05, 2026',
    icon: '🏢'
  },
  {
    id: 23,
    title: 'කොරියාව සඳහා යාමට වියදම කොපමණ වේද?',
    category: 'Korean Problems',
    shortDesc: 'කොරියානු භාෂාව හැදෑරීමේ සිට කොරියාවට යාමට පෙර පවත්වනු ලබන අවසාන දේශනය දක්වා වියදම්...',
    content: `
      <p>කොරියාවට යෑම සඳහා වියදම් වන මුදල කොපමණද යන්න ගණනය කිරීමේදී සම්පූර්ණ වියදම පහත පරිදි සරල ව පැහැදිලි කළ හැකිය:</p>
      <ul>
        <li><b>කොරියානු භාෂාව සහ නිපුණතා පරීක්ෂණය හැදෑරීම:</b> රු. 30,000/=</li>
        <li><b>විභාග ප්‍රවේශ පත්‍රය:</b> ඇ.ඩො. 24 (රු. 5,000/= පමණ)</li>
        <li><b>විදේශ සේවා නියුක්ති කාර්යාංශයේ ලියාපදිංචි ගාස්තුව:</b> රු. 16,416/=</li>
        <li><b>වීසා ගාස්තුව:</b> රු. 12,000/=</li>
        <li><b>බඳවා ගැනීමේ ගාස්තුව:</b> රු. 55,233/=</li>
        <li><b>පෙර විගමනික පුහුණුව:</b> රු. 20,000/=</li>
        <li><b>වෛද්‍ය වාර්තාව:</b> රු. 8,500/=</li>
        <li><b>පොලිස් නිශ්කාෂණ වාර්තාව:</b> රු. 1,530/=</li>
        <li><b>ගුවන් ප්‍රවේශ පත්‍රය:</b> රු. 189,000/= (මිල ගණන් වෙනස් විය හැක)</li>
        <li><b>කොරියාවට ගිය පසු නිරෝධායන ගාස්තු:</b> රු. 210,000/=</li>
        <li><b>පෞද්ගලික වියදම් සඳහා තබාගත යුතු මුදල:</b> රු. 40,000/=</li>
      </ul>
      <p><b>සමස්ත වියදම:</b> සියලු වියදම් එකතු වූ විට දල වශයෙන් <b>රු. 610,000/=</b> ක් පමණ වියදම් වන බව පෙන්වා දිය හැකිය. (විනිමය අනුපාත මත මෙම මුදල් වෙනස් විය හැක)</p>
    `,
    date: 'May 05, 2026',
    icon: '💸'
  }
];

export default function FAQ() {
  const [selectedArticle, setSelectedArticle] = useState(null);

  const openModal = (article) => {
    setSelectedArticle(article);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setSelectedArticle(null);
    document.body.style.overflow = 'unset';
  };

  return (
    <div className="faq-page">
      {/* Hero Section */}
      <ScrollReveal>
        <section className="faq-hero">
          <div className="faq-hero-content">
            <h1>ප්‍රශ්න හා පිළිතුරු</h1>
            <p>කොරියානු රැකියා සිහිනය ජය ගැනීමට ඔබට ඇති ගැටළු වලට විසඳුම් මෙතැනින්</p>
          </div>
        </section>
      </ScrollReveal>

      <div className="faq-container">


        <div className="faq-grid">
          {ARTICLES.map((article) => (
            <ScrollReveal key={article.id}>
              <div className="faq-card" onClick={() => openModal(article)}>
                <div className="faq-card-category">{article.category}</div>
                <h3 className="faq-card-title">{article.title}</h3>
                <p className="faq-card-desc">{article.shortDesc}</p>
                <div className="faq-card-footer">
                  <span className="faq-date">{article.date}</span>
                  <button className="faq-read-btn">Read Article</button>
                </div>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>

      {/* Modal */}
      {selectedArticle && (
        <div className="faq-modal-overlay" onClick={closeModal}>
          <div className="faq-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="faq-modal-close" onClick={closeModal}>&times;</button>
            <div className="faq-modal-header">
              <div className="faq-modal-meta">
                <span className="modal-category">{selectedArticle.category}</span>
                <span className="modal-date">{selectedArticle.date}</span>
              </div>
              <h2 className="faq-modal-title">{selectedArticle.title}</h2>
            </div>
            <div className="faq-modal-body" dangerouslySetInnerHTML={{ __html: selectedArticle.content }} />
            <div className="faq-modal-footer">
              <button className="faq-modal-btn" onClick={closeModal}>Close</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
